import axios from 'axios';

// Base API URL
const NOTIFICATION_API = '/api/notifications';

// Mock data to use instead of API calls
const MOCK_NOTIFICATIONS = {
  notifications: [],
  unreadCount: 0
};

/**
 * Get user notifications
 * @returns {Promise<object>} Object containing notifications array and unreadCount
 */
export const getUserNotifications = async () => {
  // Return mock data instead of making an API call
  // console.log('Using mock notifications data instead of API call');
  return MOCK_NOTIFICATIONS;
};

/**
 * Mark a notification as read
 * @param {string} notificationId - ID of the notification to mark as read
 * @returns {Promise<object>} Response data
 */
export const markNotificationAsRead = async (notificationId) => {
  // console.log(`Mock: Marking notification ${notificationId} as read`);
  return { success: true };
};

/**
 * Mark all notifications as read
 * @returns {Promise<object>} Response data
 */
export const markAllNotificationsAsRead = async () => {
  // console.log('Mock: Marking all notifications as read');
  return { success: true };
};

/**
 * Delete a notification
 * @param {string} notificationId - ID of the notification to delete
 * @returns {Promise<object>} Response data
 */
export const deleteNotification = async (notificationId) => {
  // console.log(`Mock: Deleting notification ${notificationId}`);
  return { success: true };
};

/**
 * Create a new notification (typically used by admin or system)
 * @param {object} notificationData - Notification data
 * @returns {Promise<object>} Created notification
 */
export const createNotification = async (notificationData) => {
  // console.log('Mock: Creating notification', notificationData);
  return { success: true, notification: { id: `mock-${Date.now()}`, ...notificationData } };
};

/**
 * Get notification settings
 * @returns {Promise<object>} Notification settings
 */
export const getNotificationSettings = async () => {
  // console.log('Mock: Getting notification settings');
  return { 
    enableEmailNotifications: true,
    enablePushNotifications: false,
    notifyOnNewMessage: true,
    notifyOnBillingUpdate: true,
    notifyOnSystemChanges: true
  };
};

/**
 * Update notification settings
 * @param {object} settings - New notification settings
 * @returns {Promise<object>} Updated settings
 */
export const updateNotificationSettings = async (settings) => {
  // console.log('Mock: Updating notification settings', settings);
  return { success: true, settings };
}; 